import React, { Component } from 'react';
import { Provider } from 'react-redux';
import Main from './Main';
import { BrowserRouter } from 'react-router-dom';
import { noticeError } from 'app/api/analytics/reporting';
import { PersistGate } from 'redux-persist/integration/react';
import CenteredLoader from '../core/common/CenteredLoader';
import { store, persistor } from 'app/api/redux-watson/app-config';

class App extends Component {
  state = {
    hasError: false,
  };

  componentDidMount() {
    const el = document.getElementById('staticloader');
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  componentDidCatch(e) {
    noticeError(e);
    this.setState({
      hasError: true,
    });
  }

  render() {
    if (this.state.hasError) {
      return 'Oops! Something went wrong. Please try again later!';
    }

    return (
      <Provider store={store}>
        <PersistGate
          loading={<CenteredLoader fullScreen />}
          persistor={persistor}
        >
          <BrowserRouter>
            <Main />
          </BrowserRouter>
        </PersistGate>
      </Provider>
    );
  }
}

export default App;
